export default function Footer() {
  return (
    <footer className="bg-teal text-white/90 px-6 sm:px-10 py-4 flex items-center justify-between text-sm">
      <span>
        <a href="https://www.op-consult.de/impressum" target="_blank" rel="noreferrer" className="hover:underline">Impressum</a>
        <span className="mx-2">|</span>
        <a href="https://www.op-consult.de/datenschutz" target="_blank" rel="noreferrer" className="hover:underline">Datenschutz</a>
      </span>
      <span className="hidden sm:inline">
        © {new Date().getFullYear()}{' '}
        <a href="https://www.op-consult.de" target="_blank" rel="noreferrer" className="hover:underline">O+P Consult GmbH</a>
        {' '}· Mindnet Academy
      </span>
    </footer>
  )
}
